import React from 'react';
import classnames from 'classnames';
import styles from './DelegationStatement.scss';

function DelegationStatement(props) {
    const {
        className,
        type = 'info',
        size = 'normal',
        children,
    } = props;

    const classes = classnames(className, styles[type], styles[`size--${size}`]);

    return (
        <div className={classes}>
            {children}
        </div>
    );
}

export default DelegationStatement;
